(function () {
  if (window.HabysPremium) return;
  window.HabysPremium = true;

  function fmt(cents) {
    var c = Math.round(cents);
    var e = Math.floor(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var r = ('0' + (c % 100)).slice(-2);
    return { e: e, c: r };
  }
  function priceHTML(cents, sym) {
    var p = fmt(cents);
    return p.e + '<sup>' + p.c + '</sup> ' + sym;
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-hp-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var sym = root.getAttribute('data-currency') || '€';
    var state = {};
    var first = variants.find(function (v) { return String(v.id) === root.getAttribute('data-current'); }) || variants[0];
    first.options.forEach(function (o, i) { state[i] = o; });

    function current() {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === state[i]; });
      });
    }

    function update(fromUser) {
      var v = current();
      document.querySelectorAll('[data-hp-option]').forEach(function (btn) {
        var idx = +btn.getAttribute('data-index');
        var val = btn.getAttribute('data-value');
        btn.classList.toggle('is-active', state[idx] === val);
        btn.setAttribute('aria-pressed', state[idx] === val);
        var test = Object.assign({}, state); test[idx] = val;
        var match = variants.find(function (x) { return x.options.every(function (o, i) { return o === test[i]; }); });
        btn.classList.toggle('is-unavailable', !match || !match.available);
      });
      document.querySelectorAll('[data-hp-option-label]').forEach(function (el) {
        el.textContent = state[+el.getAttribute('data-index')];
      });
      if (!v) {
        document.querySelectorAll('.hp-atc[name="add"]').forEach(function (b) { b.disabled = true; b.textContent = b.getAttribute('data-unavailable'); });
        return;
      }
      document.querySelectorAll('[data-hp-variant-input]').forEach(function (i) { i.value = v.id; });
      document.querySelectorAll('[data-hp-price]').forEach(function (el) { el.innerHTML = priceHTML(v.price, sym); });
      document.querySelectorAll('[data-hp-compare]').forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) { el.innerHTML = priceHTML(v.compare_at_price, sym); el.hidden = false; }
        else el.hidden = true;
      });
      document.querySelectorAll('[data-hp-badge]').forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          el.textContent = '– ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% Rabatt';
          el.hidden = false;
        } else el.hidden = true;
      });
      document.querySelectorAll('[data-hp-stock]').forEach(function (el) {
        el.textContent = v.available ? el.getAttribute('data-in') : el.getAttribute('data-out');
        el.classList.toggle('is-out', !v.available);
      });
      document.querySelectorAll('.hp-atc[name="add"], [data-hp-sticky-atc]').forEach(function (b) {
        b.disabled = !v.available;
        b.textContent = v.available ? b.getAttribute('data-label') : b.getAttribute('data-unavailable');
      });
      if (fromUser) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.featured_media) goToMedia(v.featured_media.id);
        document.dispatchEvent(new CustomEvent('on:variant:change', { detail: { variant: v, product: { variants: variants } } }));
      }
    }

    function goToMedia(id) {
      var slide = root.querySelector('[data-media-id="' + id + '"]');
      var track = root.querySelector('[data-hp-track]');
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    document.querySelectorAll('[data-hp-option]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        state[+btn.getAttribute('data-index')] = btn.getAttribute('data-value');
        update(true);
      });
    });
    update(false);

    /* gallery */
    var track = root.querySelector('[data-hp-track]');
    if (track) {
      var slides = track.children;
      var dots = root.querySelectorAll('[data-hp-dot]');
      function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) {
        var n = slides.length; i = (i + n) % n;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      var prev = root.querySelector('[data-hp-prev]'), next = root.querySelector('[data-hp-next]');
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = idx();
          dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
        }, 60);
      }, { passive: true });
    }

    /* related product */
    var rel = root.querySelector('[data-hp-related-auto]');
    if (rel) {
      var pid = rel.getAttribute('data-product-id');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var load = function (intent) {
        return fetch(base + 'recommendations/products.json?product_id=' + pid + '&limit=1&intent=' + intent)
          .then(function (r) { return r.json(); })
          .then(function (d) { return d.products && d.products[0]; });
      };
      load('complementary').then(function (p) { return p || load('related'); }).then(function (p) {
        if (!p) return;
        var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
        var card = rel.querySelector('.hp-related__card');
        card.href = p.url;
        card.querySelector('img').src = img;
        card.querySelector('img').alt = p.title;
        card.querySelector('.hp-related__vendor').textContent = p.vendor;
        card.querySelector('.hp-related__name').textContent = p.title;
        card.querySelector('.hp-related__price').innerHTML = priceHTML(p.price, sym);
        rel.hidden = false;
      }).catch(function () {});
    }
  }

  /* qty */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hp-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + (+b.getAttribute('data-hp-qty')));
    input.value = v;
  });

  /* countdown to dispatch cutoff (Europe/Berlin) */
  function initCountdown(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 15;
    var timeEl = el.querySelector('[data-hp-time]');
    var textEl = el.querySelector('[data-hp-cd-text]');
    function berlinNow() {
      var s = new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
      return new Date(s);
    }
    function tick() {
      var n = berlinNow();
      var day = n.getDay();
      var target = new Date(n); target.setHours(cutoff, 0, 0, 0);
      var workday = day >= 1 && day <= 5;
      if (workday && n < target) {
        var diff = Math.floor((target - n) / 1000);
        var h = Math.floor(diff / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
        timeEl.textContent = [h, m, s].map(function (x) { return ('0' + x).slice(-2); }).join(':');
        textEl.textContent = el.getAttribute('data-today');
        timeEl.hidden = false;
      } else {
        textEl.textContent = el.getAttribute('data-next');
        timeEl.hidden = true;
      }
    }
    tick(); setInterval(tick, 1000);
  }

  /* sticky bar */
  function initSticky(bar) {
    var anchor = document.querySelector('[data-hp-main-buybar]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var past = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    }).observe(anchor);
    var btn = bar.querySelector('[data-hp-sticky-atc]');
    btn.addEventListener('click', function () {
      var main = document.querySelector('[data-hp-main-buybar] .hp-atc[name="add"]');
      if (main) main.click();
    });
  }

  function boot() {
    document.querySelectorAll('[data-hp-product]').forEach(initProduct);
    document.querySelectorAll('[data-hp-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-hp-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
